import axios from 'axios';

const apiWeb = axios.create({
    //baseURL: 'http://187.86.147.193:5001/',
    baseURL: 'http://192.168.2.200:5001/',
});

export default apiWeb;